import { render, staticRenderFns } from "./OrganizationTypeAheadSelector.vue?vue&type=template&id=61dbb4c5"
import script from "./OrganizationTypeAheadSelector.vue?vue&type=script&lang=js"
export * from "./OrganizationTypeAheadSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports